.NavIcons {
  position: fixed;
  top: 2px;
  right: 100px;
  border-radius: 10px;
  padding: 10px;
  display: flex;
  gap: 5px;
  z-index: 10;
}
